import { useState } from 'react';

import LeadForm from './LeadForm';
import PageMeta from './PageMeta';
import { RedesignFooter, RedesignHeader, RedesignPage, SiteLink } from './RedesignShell';

const needItems = [
  {
    title: 'Риски при нарушении требований РКН',
    paragraphs: [
      'Нарушения могут привести к утечке данных, снижению доверия пользователей и проблемам с законом. Без проверки сайт может долго работать с ошибками, которые не видны владельцу.',
    ],
  },
  {
    title: 'Блокировки и штрафы',
    paragraphs: [
      'Если сайт попадает в реестр РКН, доступ к нему может быть ограничен. Блокировки происходят по решению суда или государственных органов. Также предусмотрены штрафы за несоблюдение требований 152-ФЗ.',
    ],
  },
  {
    title: 'Проверки Роскомнадзора',
    paragraphs: [
      'Роскомнадзор регулярно проверяет сайты. Инспекторы анализируют обработку персональных данных, документы и технические настройки. При нарушениях выдается предписание.',
    ],
  },
  {
    title: 'Защита персональных данных пользователей',
    paragraphs: ['Проверка помогает убедиться, что персональные данные защищены. Это важно для безопасности пользователей и стабильной работы сайта.'],
  },
];

const siteTypes = [
  {
    title: 'Интернет-магазины',
    paragraphs: ['Интернет-магазины обрабатывают заказы, email, телефоны и платежные данные. Такие сайты обязаны соблюдать требования РКН.'],
  },
  {
    title: 'Корпоративные сайты',
    paragraphs: ['Даже простой сайт компании может содержать формы обратной связи и сбор данных.'],
  },
  {
    title: 'Лендинги и сервисы',
    paragraphs: ['Лендинги активно используют формы, пиксели аналитики и трекеры. Это повышает риск нарушений.'],
  },
  {
    title: 'Сайты с формами сбора данных',
    paragraphs: ['Любой сайт с формами регистрации, заявок или подписки должен пройти проверку.'],
  },
];

const checkScope = [
  {
    title: 'Проверка политики обработки персональных данных',
    paragraphs: ['Проверяется наличие политики конфиденциальности, ее актуальность и соответствие закону.'],
  },
  {
    title: 'Проверка форм сбора данных',
    paragraphs: ['Анализируются формы, наличие чекбоксов согласия и корректность обработки данных.'],
  },
  {
    title: 'Проверка cookie и уведомлений',
    paragraphs: ['Сканер проверяет cookie-баннер и то, как загружаются cookies и трекеры до согласия.'],
  },
  {
    title: 'Проверка согласий пользователей',
    paragraphs: ['Проверяется, как пользователь дает согласие на обработку данных и соответствует ли это требованиям.'],
  },
  {
    title: 'Проверка хранения и обработки данных',
    paragraphs: ['Анализируется, где находятся сервера, используется ли российский хостинг и как обрабатываются данные.'],
  },
  {
    title: 'Проверка юридических страниц сайта',
    paragraphs: ['Проверяется наличие политики, оферты, пользовательского соглашения и других документов.'],
  },
];

const violationItems = [
  {
    title: 'Типовые ошибки на сайтах',
    paragraphs: ['Часто отсутствуют документы, неправильно настроены формы или нет уведомлений.'],
  },
  {
    title: 'Нарушения в обработке персональных данных',
    paragraphs: ['Данные могут передаваться без согласия пользователей или обрабатываться с нарушениями.'],
  },
  {
    title: 'Ошибки в политике конфиденциальности',
    paragraphs: ['Политика может быть устаревшей или не содержать обязательной информации.'],
  },
  {
    title: 'Отсутствие обязательных документов',
    paragraphs: ['Без политики и согласий сайт не соответствует требованиям законодательства.'],
  },
];

const lawItems = [
  {
    title: 'Соответствие 152-ФЗ',
    paragraphs: ['Сайт должен соответствовать закону о персональных данных и правилам обработки.'],
  },
  {
    title: 'Требования к персональным данным',
    paragraphs: ['Необходимо указывать цели обработки, сроки хранения и способы использования данных.'],
  },
  {
    title: 'Требования к размещению информации',
    paragraphs: ['Документы должны быть доступны пользователям и легко находиться на сайте.'],
  },
  {
    title: 'Актуальные изменения законодательства',
    paragraphs: ['Требования регулярно обновляются, поэтому важно проводить проверку сайта регулярно.'],
  },
];

const processSteps = [
  {
    title: 'Аудит сайта',
    paragraphs: ['Проводится анализ домена, IP, DNS и технических параметров сайта.'],
  },
  {
    title: 'Анализ документов',
    paragraphs: ['Проверяются юридические страницы и политика обработки данных.'],
  },
  {
    title: 'Проверка форм и функционала',
    paragraphs: ['Анализируется работа форм, cookies, трекеров и сбор данных.'],
  },
  {
    title: 'Подготовка отчета',
    paragraphs: ['Формируется отчет с результатами проверки и статусом сайта.'],
  },
  {
    title: 'Рекомендации по устранению нарушений',
    paragraphs: ['Составляется список действий и план исправления.'],
  },
];

const resultItems = [
  {
    title: 'Полный отчет по сайту',
    paragraphs: ['Отчет включает анализ домена, IP, реестра и всех параметров сайта.'],
  },
  {
    title: 'Список нарушений РКН',
    paragraphs: ['Показываются все найденные нарушения и их причины.'],
  },
  {
    title: 'Рекомендации по исправлению',
    paragraphs: ['Вы получите конкретные шаги по устранению проблем.'],
  },
  {
    title: 'Готовые решения для внедрения',
    paragraphs: ['Предлагаются решения, которые можно быстро внедрить.'],
  },
];

const tariffRows = [
  ['Тариф', 'Объем проверки', 'Что входит', 'Цена'],
  ['Базовый', 'Один сайт', 'Базовая проверка, статус, отчет', 'от 10 000 ₽'],
  ['Стандарт', 'До 50 страниц', 'Расширенный аудит и рекомендации', 'от 25 000 ₽'],
  ['Бизнес', 'До 100 страниц', 'Полная проверка и анализ нарушений', 'от 45 000 ₽'],
  ['Премиум', 'Без ограничений', 'Аудит + внедрение и сопровождение', 'от 80 000 ₽'],
];

const faqItems = [
  {
    question: 'Нужно ли проверять сайт на РКН обязательно?',
    answer: 'Да, если сайт собирает или обрабатывает персональные данные пользователей.',
  },
  {
    question: 'Сколько времени занимает проверка сайта?',
    answer: 'Проверка занимает от нескольких минут до нескольких дней в зависимости от объема.',
  },
  {
    question: 'Можно ли заказать только аудит без внедрения?',
    answer: 'Да, можно заказать только проверку сайта и получить отчет.',
  },
  {
    question: 'Что делать после проверки сайта?',
    answer: 'Необходимо устранить нарушения и привести сайт в соответствие требованиям РКН.',
  },
];

function Paragraphs({ paragraphs }) {
  return paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>);
}

function SectionHeader({ eyebrow, title, description, dark = false }) {
  return (
    <div className={`sec-head${dark ? ' ink-head' : ''}`}>
      <div>
        <div className={`eyebrow${dark ? ' cyan' : ''}`}>{eyebrow}</div>
        <h2>{title}</h2>
      </div>
      {description && <p className="sub">{description}</p>}
    </div>
  );
}

function Cards({ items }) {
  return (
    <div className="compact-card-grid">
      {items.map((item, index) => (
        <div className="compact-card" key={item.title}>
          <div className="compact-num">{String(index + 1).padStart(2, '0')}</div>
          <h3>{item.title}</h3>
          <Paragraphs paragraphs={item.paragraphs} />
        </div>
      ))}
    </div>
  );
}

function ProcessRail({ items }) {
  return (
    <div className="process-rail process-rail-five">
      {items.map((item, index) => (
        <div className="process-step" key={item.title}>
          <div className="process-num">{String(index + 1).padStart(2, '0')}</div>
          <h3>{item.title}</h3>
          <Paragraphs paragraphs={item.paragraphs} />
        </div>
      ))}
    </div>
  );
}

function RknCheckPage() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <RedesignPage>
      <PageMeta
        title="Проверка сайта на требования РКН — аудит и анализ нарушений"
        description="Закажите проверку сайта для РКН (Роскомнадзора). Аудит на соответствие 152-ФЗ, проверка cookie, форм, политики конфиденциальности и персональных данных. Найдем нарушения, подготовим отчет и рекомендации. Системный подход, множество кейсов и команда профессионалов. Уже помогли более 35 сайтам избежать блокировок РКН. Рассчитайте стоимость в веб-студии fatalitystudio.ru или по телефону +7 (925) 653-04-54 !"
      />
      <RedesignHeader />

      <section className="ink service-hero">
        <div
          className="glow"
          style={{ right: '-360px', top: '-340px', width: '980px', height: '980px', opacity: 0.1 }}
        />
        <div className="container service-hero-grid">
          <div>
            <div className="eyebrow cyan">— РКН</div>
            <h1>Проверка сайта для РКН и соответствие требованиям законодательства</h1>
            <p className="hero-sub">
              Проверка сайта для РКН — это комплексный аудит, который помогает проверить сайт на соответствие требованиям
              законодательства РФ. Такой анализ позволяет выявить нарушения, оценить риски блокировки и понять,
              соответствует ли сайт нормам 152-ФЗ. Проверка включает анализ домена, IP, URL, работы сервера, политики
              конфиденциальности и обработки персональных данных пользователей. После проверки вы получите подробный отчет
              и рекомендации.
            </p>
            <div className="hero-ctas">
              <SiteLink href="#rkn-lead" className="btn btn-primary">
                Получить расчёт бесплатно
              </SiteLink>
              <SiteLink href="#rkn-price" className="btn btn-ghost-dark">
                Проверка сайта для РКН — тарифы
              </SiteLink>
            </div>
          </div>
          <div className="service-hero-panel" aria-label="Что входит в проверку сайта на требования РКН">
            {checkScope.slice(0, 5).map((item, index) => (
              <div className="panel-line" key={item.title}>
                <span>{String(index + 1).padStart(2, '0')}</span>
                <b>{item.title}</b>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— соответствие"
            title="Проверка сайта на соответствие требованиям РКН"
            description="Проверка сайта на соответствие требованиям РКН проводится с использованием автоматических и ручных инструментов. Сервис проверяет домен, IP-адрес и URL сайта, а также анализирует, находится ли ресурс в реестре Роскомнадзора."
          />
          <div className="split-proof">
            <div>
              <p>
                Дополнительно выполняется проверка SSL-сертификата, DNS-записей, настроек хостинга и безопасности. Сканер
                проверяет, как сайт работает с cookies, есть ли уведомления и согласия пользователей.
              </p>
            </div>
            <div>
              <p>После запуска проверки система автоматически покажет статус сайта, выявит нарушения и даст рекомендации.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— зачем"
            title="Зачем нужна проверка сайта для РКН"
            description="Проверка сайта необходима для любого бизнеса, который работает с пользователями и обрабатывает персональные данные. Роскомнадзор контролирует соблюдение требований и ведет реестр нарушений."
          />
          <Cards items={needItems} />
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— кому"
            title="Какие сайты необходимо проверять на требования РКН"
            description="Проверка актуальна для любых сайтов, которые собирают или обрабатывают данные пользователей."
            dark
          />
          <Cards items={siteTypes} />
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— состав проверки"
            title="Что входит в проверку сайта на требования РКН"
            description="Проверка сайта включает анализ всех элементов, связанных с обработкой данных и безопасностью."
          />
          <Cards items={checkScope} />
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— нарушения"
            title="Проверка сайта на нарушения РКН"
            description="Аудит позволяет выявить типичные нарушения, которые встречаются на большинстве сайтов."
          />
          <Cards items={violationItems} />
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— закон"
            title="Проверка сайта на нормы РКН и закона"
            description="Проверка учитывает актуальные требования законодательства РФ."
            dark
          />
          <Cards items={lawItems} />
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— процесс"
            title="Как проходит проверка сайта для РКН"
            description="Проверка сайта проходит в несколько этапов и занимает от нескольких минут до нескольких дней."
          />
          <ProcessRail items={processSteps} />
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— результат"
            title="Что вы получаете после проверки"
            description="После проверки сайта вы получите полный набор данных для работы."
          />
          <Cards items={resultItems} />
        </div>
      </section>

      <section className="canvas sec-pad section-line-top" id="rkn-price">
        <div className="container">
          <SectionHeader
            eyebrow="— стоимость"
            title="Стоимость проверки сайта для РКН"
            description="Стоимость зависит от объема сайта, количества страниц и глубины анализа."
          />
          <div className="pricing-layout">
            <div className="price-list">
              <h3 className="pricing-subhead">Сколько стоит проверка сайта для РКН</h3>
              <p className="pricing-copy">Цена формируется исходя из сложности проекта и задач.</p>
              <h3 className="pricing-subhead">От чего зависит стоимость</h3>
              <p className="pricing-copy">Влияют CMS, интеграции, наличие аналитики, структура сайта и объем данных.</p>
              <h3 className="pricing-subhead">Проверка сайта для РКН — тарифы</h3>
              <div className="price-table-scroll">
                <table className="rkn-tariff-table">
                  <thead>
                    <tr>
                      {tariffRows[0].map((cell) => <th scope="col" key={cell}>{cell}</th>)}
                    </tr>
                  </thead>
                  <tbody>
                    {tariffRows.slice(1).map((row) => (
                      <tr key={row.join('|')}>
                        {row.map((cell, cellIndex) => (
                          cellIndex === 0
                            ? <th scope="row" key={cell}>{cell}</th>
                            : <td key={cell}>{cell}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="price-note">
              <h3>Получить расчет стоимости</h3>
              <p>Чтобы получить расчет, отправьте адрес сайта. Специалисты проведут анализ и предложат решение.</p>
              {/* TODO(brand-redesign): add the manager trust block after the source photo and manager name are provided. */}
              <LeadForm
                formId="rkn-calc-form"
                idPrefix="rkn-calc"
                contactLabel="Телефон или E-mail"
                contactType="text"
                contactPlaceholder="+7 или почта"
                showTelegram={false}
                showCompany={false}
                typeLabel="Тип сайта"
                typeOptions={['Один сайт', 'До 50 страниц', 'До 100 страниц', 'Без ограничений']}
                submitLabel="Получить расчёт бесплатно"
                taskPlaceholder="Отправьте адрес сайта"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <div className="faq-grid">
            <div>
              <div className="eyebrow">— faq</div>
              <h2 className="standalone-h2">Ответы на частые вопросы</h2>
            </div>
            <div className="faq-list">
              {faqItems.map((item, index) => {
                const isOpen = openFaq === index;
                return (
                  <div className={`faq-item${isOpen ? ' open' : ''}`} key={item.question}>
                    <div className="faq-q">
                      <h3 className="faq-question-heading">
                        <button
                          aria-controls={`rkn-faq-answer-${index}`}
                          aria-expanded={isOpen}
                          className="faq-question-button"
                          type="button"
                          onClick={() => setOpenFaq(isOpen ? -1 : index)}
                        >
                          {item.question}
                        </button>
                      </h3>
                      <span className="faq-toggle" aria-hidden="true">+</span>
                    </div>
                    <div className="faq-a" id={`rkn-faq-answer-${index}`}>
                      <div className="faq-a-inner">
                        <p>{item.answer}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section className="ink lead" id="rkn-lead">
        <div
          className="glow"
          style={{ left: '-300px', top: '-200px', width: '700px', height: '700px', opacity: 0.1 }}
        />
        <div className="container" style={{ position: 'relative' }}>
          <div className="lead-grid">
            <div className="lead-side">
              <div className="eyebrow cyan">— заявка</div>
              <h2 className="lead-heading">Заказать проверку сайта на требования РКН</h2>
              <p className="lead-text">
                Проверка сайта для РКН помогает избежать блокировки, штрафов и проблем с законом. Закажите аудит, чтобы
                проверить сайт, выявить нарушения и повысить безопасность. Специалисты проведут проверку, подготовят отчет
                и помогут внедрить все необходимые изменения.
              </p>
            </div>
            <LeadForm
              formId="rkn-lead-form"
              idPrefix="rkn"
              contactLabel="Телефон или E-mail"
              contactType="text"
              contactPlaceholder="+7 или почта"
              showTelegram={false}
              showCompany={false}
              typeLabel="Тип сайта"
              typeOptions={['Один сайт', 'До 50 страниц', 'До 100 страниц', 'Без ограничений']}
              submitLabel="Получить расчёт бесплатно"
              taskPlaceholder="Отправьте адрес сайта"
            />
          </div>
        </div>
      </section>

      <RedesignFooter />
    </RedesignPage>
  );
}

export default RknCheckPage;
